import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { useMobileDialogDispatch } from './MobileDialogContext';
import SvgChevron from '../../../../play-core/icons/Chevron';
import SvgClose from '../../../../play-core/icons/Close';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { ellipsis } from '../../../../play-core/styles/style-helper';
import { zIndex } from '../../../../play-core/styles/z-index';
import { headerShadow } from '../Header/Header.globals';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { LoadingBar } from '../LoadingBar/LoadingBar';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MobileDialogHeader = ({
  closeIcon,
  title,
  actionVisible = false,
  actionText,
  onAction,
  onClose,
  isLoading = false,
  noMargin = false
}) => {
  const dispatch = useMobileDialogDispatch();
  const {
    t
  } = useTranslation();
  const icon = closeIcon === 'back' ? /*#__PURE__*/_jsx(SvgChevron, {
    orientation: "left"
  }) : /*#__PURE__*/_jsx(SvgClose, {});
  return /*#__PURE__*/_jsx(Header, {
    noMargin: noMargin,
    children: /*#__PURE__*/_jsxs(StickyContainer, {
      noMargin: noMargin,
      children: [/*#__PURE__*/_jsx(LoadingBar, {
        isLoading: isLoading
      }), /*#__PURE__*/_jsx(CloseButton, {
        "aria-label": t('global.close'),
        onClick: () => {
          onClose && onClose();
          dispatch({
            type: 'close'
          });
        },
        children: /*#__PURE__*/_jsx(IconWrapper, {
          icon: icon,
          color: Colors.GREY_d2d2d2
        })
      }), title && /*#__PURE__*/_jsx(Title, {
        children: title
      }), actionVisible && /*#__PURE__*/_jsx(ActionButton, {
        onClick: onAction,
        children: actionText
      })]
    })
  });
};
const mobileHeaderHeight = 64;
const bottomMargin = 8;
const Header = styled.header.withConfig({
  displayName: "MobileDialogHeader__Header",
  componentId: "sc-pxm1dp-0"
})(["position:relative;min-height:", "px;background-color:", ";"], props => mobileHeaderHeight + (props.noMargin ? 0 : bottomMargin), Colors.GREY_1a1a1a);
const StickyContainer = styled.div.withConfig({
  displayName: "MobileDialogHeader__StickyContainer",
  componentId: "sc-pxm1dp-1"
})(["position:fixed;right:0;left:0;z-index:", ";display:flex;justify-content:space-between;width:100%;height:", "px;margin-bottom:", "px;background-color:", ";", ";"], zIndex.header, mobileHeaderHeight, props => props.noMargin ? 0 : bottomMargin, Colors.GREY_1a1a1a, headerShadow);
const CloseButton = styled.button.withConfig({
  displayName: "MobileDialogHeader__CloseButton",
  componentId: "sc-pxm1dp-2"
})(["padding:0 20px;color:", ";&:active{background-color:", ";}"], Colors.GREY_d2d2d2, Colors.GREY_222222);
const Title = styled.h3.withConfig({
  displayName: "MobileDialogHeader__Title",
  componentId: "sc-pxm1dp-3"
})(["", ";color:", ";flex-grow:1;padding-left:32px;", ";"], Fonts.regular(20), Colors.GREY_d2d2d2, ellipsis);
const ActionButton = styled.button.withConfig({
  displayName: "MobileDialogHeader__ActionButton",
  componentId: "sc-pxm1dp-4"
})(["padding:0 20px 0 5px;", ";color:", ";&:active{background-color:", ";}"], Fonts.regular(14), Colors.GREY_d2d2d2, Colors.GREY_222222);